export const expiresDaysMarketingSourceTags = 30;
export const BTAG_SET_DATE = 'btagSetDate';
export const MARKETING_DATA = 'marketingData';
export const marketingAttributionData = 'marketingAttributionData';
export const AcquisitionSourcesLength = 'marketing.acquisition-sources-length';
export const registerAttributionHistory = 'register-attribution-history-';
export const ftdAttributionHistory = 'ftd-attribution-history-';

export const btagQueryParams = [
    'btag',
    'affid',
];

export const utmQueryParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
];

export const UTM_DATA = 'utmData';

export function isAffiliateLanding(location: Location = window.location) {
    const params = new URLSearchParams(location.search);
    return [
        ...btagQueryParams,
        ...utmQueryParams,
    ].some((param) => params.has(param));
}
